<div class="header">
    <h2 mat-dialog-title>{{ dialogTitle }}</h2>
    <div *ngIf="result" class="text-muted">ID: {{ result.id }}</div>
</div>
<mat-dialog-content>
<form [formGroup]="form">
    <fieldset class="field-details">
        <fui-fieldset-legend label="Field details" i18n-label>
        </fui-fieldset-legend>

        <mat-form-field appearance="outline">
            <mat-label i18n>Field type</mat-label>
            <mat-select formControlName="type">
                <mat-optgroup label="Basic fields" i18n-label>
                    <mat-option *ngFor="let fieldType of basicFields" [value]="fieldType.id">
                        {{ fieldType.name }}
                    </mat-option>
                </mat-optgroup>
                <mat-optgroup label="User fields" i18n-label>
                    <mat-option *ngFor="let fieldType of userFields" [value]="fieldType.id">
                        {{ fieldType.name }}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
            <mat-hint i18n>What type of data should the user enter into this field?</mat-hint>
        </mat-form-field>

        <mat-form-field *ngIf="shouldCaptureName" appearance="outline">
            <mat-label i18n>Field name</mat-label>
            <input matInput type="text" formControlName="name">
            <mat-hint i18n>What name should be shown to users viewing this field?</mat-hint>
        </mat-form-field>

        <fui-value-list-control *ngIf="shouldAllowManageSelectOptions"
                               formControlName="availableValues"
                               title="Select options"
                               [captureKeys]="false"
                               i18n-title>
        </fui-value-list-control>

        <!-- Handle custom properties for a user field -->
        @if (allowManageRoles) {
            <mat-form-field appearance="outline">
                <mat-label i18n>Filter by roles</mat-label>
                <mat-select multiple formControlName="roles">
                    <mat-option *ngFor="let option of availableRoles" [value]="option" [title]="option.name">{{ option.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        }

        <mat-form-field *ngIf="selectedType?.isContentRequired" appearance="outline">
            <mat-label>{{ selectedType?.name }} content</mat-label>
            <textarea matInput formControlName="content"></textarea>
        </mat-form-field>

        <ng-container *ngIf="selectedType?.isUserEditable">
            <div class="form-field">
                <mat-checkbox formControlName="required" i18n>Make this a required field?</mat-checkbox>
            </div>
        </ng-container>

        <eas-workflow-form-field-form-visibility formControlName="visibility"
                                                 [availableFields]="conditionalVisiblityFields()">
        </eas-workflow-form-field-form-visibility>
    </fieldset>
    <fieldset>
        <fui-fieldset-legend label="Field permissions" i18n-label>
        </fui-fieldset-legend>
        <p i18n *ngIf="isUsed">
            '{{ form.value['name'] }}' field is used by
            <strong>{{ numberOfRoles | i18nPlural: pluralMapping['role'] }}</strong>
            and
            <strong>{{ numberOfStates | i18nPlural: pluralMapping['state'] }}</strong>.
        </p>
        <p i18n *ngIf="!isUsed">This field is not used by any roles or states.</p>
    </fieldset>

    <fieldset *ngIf="fieldValidatorsDescription()">
        <fui-fieldset-legend label="Field custom validators" i18n-label>
        </fui-fieldset-legend>
        <p>{{ fieldValidatorsDescription() }}</p>
    </fieldset>

</form>
</mat-dialog-content>

<mat-dialog-actions>
    <div>
        <button i18n
                *ngIf="shouldShowDelete"
                mat-flat-button
                color="warn"
                (click)="onDelete()"
                tabindex="-1">Delete field</button>
        <p i18n
           *ngIf="isUsed"
           class="text-muted small">Deleting the field removes it completely from the form. This will therefore remove it from being visible for all specified roles and state.</p>
    </div>
    <div>
        <button i18n mat-button
                (click)="onCancel()"
                tabindex="-1"
                >Discard</button>
        <button type="submit"
                mat-flat-button
                color="primary"
                (click)="onSave()"
                [disabled]="!form.valid">{{ submitButtonTitle }}</button>
    </div>
</mat-dialog-actions>
